import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

import { AuthService } from '../../../services/auth.service';
import { EnvService } from '../../../services/env.service';
import { CommonService } from '../../../services/common.service';

@Component({
	selector: 'app-smspay',
	templateUrl: './smspay.component.html',
	styleUrls: ['./smspay.component.css']
})
export class SmspayComponent implements OnInit {

	admPageObj:any = "curr";

	frm : FormGroup;

	logi_user:any;
	smsList:any;
	smsData:any = [];

	/* 페이징 */
	cp:any = 1;
	paging:any = [];
	paging_start:any = [];
	paging_end:any = [];

	total_cnt:any = 0;

	smsPrice:any = "16,500원";

	/* 검색관련 */
	skey:any = "";
	sw:any = "";

	constructor(
		private http: HttpClient,
		private router: Router,
		private fb: FormBuilder,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {
		this.frm = fb.group({
			sms_cnt: ['1000'],
			bank_account: ['', [Validators.required]],
			deposit_name: ['', [Validators.required]],
		});
	}

	ngOnInit() {
		this.getSmsData()
	}

	async getSmsData() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		this.http.post(this.env.API_URL + 'api/sms.data.php', formData).subscribe((response) => {
			this.smsData = response['data'];
		});
	}

	async payForm() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		formData.append("smscnt", this.frm.get('sms_cnt').value);
		formData.append("bankaccount", this.frm.get('bank_account').value);
		formData.append("depositname", this.frm.get('deposit_name').value);

		this.func.prcLoading();

		this.http.post(this.env.API_URL + 'api/sms.process_order.php', formData).subscribe((response) => {
			this.func.closeLoading();

			setTimeout(() => {
				this.router.navigate(['/admin/sms/smsorder']);
			}, 1500);
		});
	}

	changePrice() {
		var cnt = this.frm.get('sms_cnt').value;

		this.smsPrice = this.comma(cnt * 16.5)+"원";
	}

	comma(num) {
		var regexp = /\B(?=(\d{3})+(?!\d))/g;
		return num.toString().replace(regexp, ',');
	}
}
